export const capitalizeFirstLetter = (string: string) => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
};

export const removePrefixName = (name: string) => {
    const split = name.split('-prefix-');
    return split.length > 1 ? split[1] : split[0];
};

export const getCleanName = (name: string) => {
    const split = name.split('*_*');
    return split.length > 1 ? split[1] : split[0];
};
